// middleware.constants.js

export const PUBLIC_ROUTES = ["/on-board", "/invitation", "/password-reset"];
export const VIEW_ONLY_ROUTES = ["/shared-asset"];

export const ROLE = {
    USER: 4,
    OWNER: 1,
    ADMIN: 2,
    MANAGER: 3
};

export const RESTRICTED_FOR_USER = [
    "/campaigns/create",
    "/campaigns/customize/",
    "/ai-campaigns",
    "/brand-management",
];
